import { render, staticRenderFns } from "./AttemptDetailsComponent.vue?vue&type=template&id=18a21132&scoped=true&"
import script from "./AttemptDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./AttemptDetailsComponent.vue?vue&type=script&lang=js&"
import style0 from "./AttemptDetailsComponent.vue?vue&type=style&index=0&id=18a21132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a21132",
  null
  
)

export default component.exports